
import React from 'react';
import GasForm from './layout/GasForm';

export default function Contatto() {
    return (        
        <GasForm title={"Contatto"}
                    getAction="/contatto/id/{id}"
                    saveAction="/cucontatto"
                    showConfirmation={false}
        />
    );
}